import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";

export class RewardIfTrueBlock extends RewardGraphNode {
    /**
     * Create a new ConditionBlock
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("eval", RewardGraphConnectionPointTypes.Boolean);
        this.registerInput("ifTrue", RewardGraphConnectionPointTypes.AutoDetect, true, 1);
        this.registerInput("ifFalse", RewardGraphConnectionPointTypes.AutoDetect, true, 0);

        this.registerOutput("output", RewardGraphConnectionPointTypes.BasedOnInput);

        this._outputs[0]._typeConnectionSource = this._inputs[1];
        this._outputs[0]._defaultConnectionPointType = RewardGraphConnectionPointTypes.Boolean;
        this._linkConnectionTypes(1, 2);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardIfTrueBlock";
    }

    /**
     * Gets the left input component
     */
    public get eval(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the ifTrue input component
     */
    public get ifTrue(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the ifFalse input component
     */
    public get ifFalse(): RewardGraphConnectionPoint {
        return this._inputs[2];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.eval.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state) => {
            if (this.eval.getConnectedValue(state)) {
                return this.ifTrue.getConnectedValue(state);
            }

            return this.ifFalse.getConnectedValue(state);
        };
    }
}

RegisterClass("MELS.RewardIfTrueBlock", RewardIfTrueBlock);
